<div class="tw-flex tw-items-center tw-gap-4 tw-rounded-2.5 tw-bg-gray-100 tw-pl-2 tw-pr-2">
  <img class="tw-h-12 tw-w-12 tw-shrink-0"
    [src]="iconSrc()"
    alt="" />
  <p class="tw-py-3 tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">
    <ng-content></ng-content>
  </p>
</div>
